module.exports = __webpack_public_path__ + "img/zhaohuiReport2.d3ac9ed2.png";